export const mapboxAccessToken = process.env.VUE_APP_MAPBOX_TOKEN
export const maxVehicleAgeOptions = [
  { label: '20 Years', value: '20' },
  { label: '19 Years', value: '19' },
  { label: '18 Years', value: '18' },
  { label: '17 Years', value: '17' },
  { label: '16 Years', value: '16' },
  { label: '15 Years', value: '15' },
  { label: '14 Years', value: '14' },
  { label: '13 Years', value: '13' },
  { label: '12 Years', value: '12' },
  { label: '11 Years', value: '11' },
  { label: '10 Years', value: '10' },
  { label: '9 Years', value: '9' },
  { label: '8 Years', value: '8' },
  { label: '7 Years', value: '7' },
  { label: '6 Years', value: '6' },
  { label: '5 Years', value: '5' },
  { label: '4 Years', value: '4' },
  { label: '3 Years', value: '3' },
  { label: '2 Years', value: '2' },
  { label: '1 Years', value: '1' },
]

export const gradeOptions = [
  { value: 'PK', label: 'PK' },
  { value: 'K', label: 'K' },
  { value: 1, label: '1st' },
  { value: 2, label: '2nd' },
  { value: 3, label: '3rd' },
  { value: 4, label: '4th' },
  { value: 5, label: '5th' },
  { value: 6, label: '6th' },
  { value: 7, label: '7th' },
  { value: 8, label: '8th' },
  { value: 9, label: '9th' },
  { value: 10, label: '10th' },
  { value: 11, label: '11th' },
  { value: 12, label: '12th' },
  { value: 13, label: '12+' },
]

export const maxRouteLengthTimeOptions = [
  { label: 'Time', value: 0 },
  {
    label: '15 mins',
    value: 15,
  },
  {
    label: '20 mins',
    value: 20,
  },
  {
    label: '25 mins',
    value: 25,
  },
  {
    label: '30 mins',
    value: 30,
  },
  {
    label: '35 mins',
    value: 35,
  },
  {
    label: '40 mins',
    value: 40,
  },
  {
    label: '45 mins',
    value: 45,
  },
  {
    label: '50 mins',
    value: 50,
  },
  {
    label: '55 mins',
    value: 55,
  },
  {
    label: '60 mins',
    value: 60,
  },
  {
    label: '90 mins',
    value: 90,
  },
]

export const stopDistanceFeetOptions = [
  { label: 'Feet', value: 0 },
  { label: 'Home (Address)', value: 1 },
  { label: '500 Feet', value: 500 },
  { label: '600 Feet', value: 600 },
  { label: '700 Feet', value: 700 },
  { label: '800 Feet', value: 800 },
  { label: '900 Feet', value: 900 },
  { label: '1000 Feet', value: 1000 },
  { label: '1100 Feet', value: 1100 },
  { label: '1200 Feet', value: 1200 },
  { label: '1300 Feet', value: 1300 },
  { label: '1400 Feet', value: 1400 },
  { label: '1500 Feet', value: 1500 },
  { label: '1600 Feet', value: 1600 },
  { label: '1700 Feet', value: 1700 },
  { label: '1800 Feet', value: 1800 },
  { label: '1900 Feet', value: 1900 },
  { label: '2000 Feet', value: 2000 },
]

export const PLACES_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places'
export const DRIVING_TRAFFIC_URL = 'https://api.mapbox.com/directions/v5/mapbox/driving-traffic'
export const DRIVING_URL = 'https://api.mapbox.com/directions/v5/mapbox/driving'
export const WALKING_URL = 'https://api.mapbox.com/directions/v5/mapbox/walking'
export const OPTIMIZATION_URL = 'https://api.mapbox.com/optimized-trips/v1/mapbox/driving-traffic'
export const ISODISTANCE_URL = 'https://api.mapbox.com/isochrone/v1/mapbox'
// Custom OSRM base URL
export const OSRM_URL = 'https://osrm.linda.systems'

// Linda Augustus API (powers the Maps layer features: activity, signal, schools, stops, etc.)
// Endpoints live under `<base>/api/...` — keep this as the host root, not including `/api`.
export const LINDA_API_URL = process.env.VUE_APP_AUGUSTUS_API_URL
export const LINDA_API_KEY = process.env.VUE_APP_AUGUSTUS_API_KEY

export const EMPLOYEE_RELATION_OPTIONS = [
  { label: 'Parent', value: 'Parent' },
  { label: 'Guardian', value: 'Guardian' },
  { label: 'Sibling', value: 'Sibling' },
  { label: 'Relative', value: 'Relative' },
  { label: 'Child', value: 'Child' },
  { label: 'Friend', value: 'Friend' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Partner', value: 'Partner' },
  { label: 'Roommate', value: 'Roommate' },
]

export const STUDENT_REQUIREMENT_OPTIONS = [
  { label: 'Air Conditioning', value: 'airConditioning' },
  { label: 'Booster Seat', value: 'boosterSeat' },
  { label: 'Buckle Guard', value: 'buckleGuard' },
  { label: 'Car Seat', value: 'carSeat' },
  { label: 'Driver Assistant - dedicated - 1', value: 'driverAssistantDedicated1' },
  { label: 'Driver Assistant - dedicated - 2', value: 'driverAssistantDedicated2' },
  { label: 'Driver Assistant - dedicated - 3', value: 'driverAssistantDedicated3' },
  { label: 'Driver Assistant - shared', value: 'driverAssistantShared' },
  { label: 'EpiPen', value: 'epiPen' },
  { label: 'Five Point Harness', value: 'fivePointHarness' },
  { label: 'Harness', value: 'harness' },
  { label: 'Houdini Harness', value: 'houdiniHarness' },
  { label: 'Independent Aide', value: 'independentAide' },
  { label: 'Private Nurse', value: 'privateNurse' },
  { label: 'Seizure Prone', value: 'seizureProne' },
  { label: 'Star Seat', value: 'starSeat' },
  { label: 'Wheelchair', value: 'wheelchair' },
  { label: 'Window Cushion', value: 'windowCushion' },
  { label: 'Zipper Harness', value: 'zipperHarness' },
]

// Requirement value -> label lookup, derived from STUDENT_REQUIREMENT_OPTIONS so
// the two can never drift. Used for requirement badges (schematic / ridership).
export const STUDENT_REQUIREMENT_LABELS = Object.fromEntries(
  STUDENT_REQUIREMENT_OPTIONS.map((option) => [option.value, option.label]),
)

// Student stop preference (Matt 7/30): `corner*` = "Corner Stop" (regular ed),
// `curb*` = "Curb Stop" (special ed — the old "House Stop" folds into "Curb").
// Value = label = meaning after the 7/30 `house*` -> `curb*` data migration.
export const STUDENT_STOP_PREFERENCE_OPTIONS = [
  { label: 'Corner Stop', value: 'corner' },
  { label: 'Corner Stop with parent/guardian', value: 'corner_parent_guardian' },
  { label: 'Corner Stop with adult', value: 'corner_adult' },
  { label: 'Curb Stop', value: 'curb' },
  { label: 'Curb Stop with parent/guardian', value: 'curb_parent_guardian' },
  { label: 'Curb Stop with adult', value: 'curb_adult' },
]

// Stop preference value -> label lookup, derived so the two can never drift.
export const STUDENT_STOP_PREFERENCE_LABELS = Object.fromEntries(
  STUDENT_STOP_PREFERENCE_OPTIONS.map((option) => [option.value, option.label]),
)

export const CALENDAR_COLORS = [
  // Primary colors (vibrant and distinct)
  '#4da6ff',
  '#28a745',
  '#ffc107',
  '#dc3545',
  '#6f42c1',
  '#17a2b8',
  '#fd7e14',
  '#e83e8c',

  // Additional vibrant colors
  '#ff6b6b',
  '#4ecdc4',
  '#45b7d1',
  '#96ceb4',
  '#ffeaa7',
  '#dda0dd',
  '#98d8c8',
  '#f7dc6f',
  '#bb8fce',
  '#85c1e9',
  '#f8c471',
  '#82e0aa',
  '#f1948a',
  '#85c1e9',
  '#d2b4de',
  '#a3e4d7',

  // Darker variants for contrast
  '#2c3e50',
  '#8e44ad',
  '#e67e22',
  '#e74c3c',
  '#3498db',
  '#1abc9c',
  '#f39c12',
  '#9b59b6',
  '#34495e',
  '#16a085',
  '#27ae60',
  '#2980b9',
  '#8b4513',
  '#556b2f',
  '#800080',
  '#008080',

  // Lighter but distinct colors
  '#ffb3ba',
  '#bae1ff',
  '#baffc9',
  '#ffffba',
  '#ffdfba',
  '#e0bbe4',
  '#957dad',
  '#d291bc',
  '#fec8d8',
  '#ffd3a5',
  '#a8edea',
  '#fed6e3',
  '#d299c2',
  '#fad0c4',
  '#6a4c93',
  '#c2e9fb',

  // Professional colors
  '#36454f',
  '#4a5d23',
  '#722f37',
  '#0f4c75',
  '#3282f6',
  '#1b1464',
  '#0b6623',
  '#990000',
  '#cc8899',
  '#836953',
  '#2f4f4f',
  '#483c32',
  '#1c1c1c',
  '#4b0082',
  '#b22222',
  '#2e8b57',
]
